import axios from '../utils/axios';
import { ApiResponseBody } from '../types/subscription';
import { ReferralLinkPayload } from '../types/referral';

const unwrapBody = <T,>(response: { data: ApiResponseBody<T> }) => response.data.body;

export const referralApi = {
    getReferralLink: async () => unwrapBody<ReferralLinkPayload>(await axios.get('/api/referral-link', { silent: true })),
};
